import React from 'react'
import { NoFilterResults } from 'src/components/PageLayout/NoFilterResults'
import { TableListLoader } from 'src/components/Reusable/ContentLoaders/TableListLoader'
import { EvidenceWrapper } from '@trustero/trustero-api-web/lib/attachment/attachment_pb'
import { NoResults } from 'src/components/PageLayout/NoResults'
import { large } from 'src/components/Icons/EmptyStateIcons/styles'
import { StandardOpenModalButton } from 'src/components/ModalForms/ModalButtons'
import {
  StandardButtonSize,
  StandardButtonVariant,
} from 'src/components/Reusable/Buttons'
import { ModalFormId } from 'src/components/ModalForms'
import { EvidenceGrid } from '../grid/EvidenceGrid'
import { EvidenceIcon } from '../evidence.styles'

export const EvidenceIndexGrid = ({
  evidence,
  hasEvidence,
  isLoading,
  onUpdate,
  allowAdd = true,
  emptyStateTitle,
  emptyStateNote,
}: {
  evidence: EvidenceWrapper[]
  hasEvidence: boolean
  isLoading: boolean
  onUpdate: () => Promise<void>
  allowAdd?: boolean
  emptyStateTitle?: string
  emptyStateNote?: string
}): JSX.Element => (
  <div
    style={{ width: '100%', maxWidth: '100%', minWidth: 0, overflowX: 'auto' }}
  >
    {isLoading ? (
      <TableListLoader rows={10} />
    ) : !hasEvidence ? (
      <NoResults
        icons={<EvidenceIcon style={large} />}
        title={emptyStateTitle || 'You have no evidence yet.'}
        note={
          emptyStateNote ||
          'Add evidence to show that you are compliant with your controls.'
        }
        buttons={
          allowAdd && !emptyStateTitle ? (
            <StandardOpenModalButton
              variant={StandardButtonVariant.PRIMARY}
              size={StandardButtonSize.MEDIUM}
              modalId={ModalFormId.ADD_EVIDENCE_GROUPS}
              text="Add Evidence"
            />
          ) : undefined
        }
      />
    ) : (
      <>
        {evidence.length > 0 ? (
          <EvidenceGrid evidenceWrappers={evidence} onUpdate={onUpdate} />
        ) : emptyStateTitle ? (
          <NoResults
            icons={<EvidenceIcon style={large} />}
            title={emptyStateTitle}
            note={emptyStateNote || ''}
          />
        ) : (
          <NoFilterResults />
        )}
      </>
    )}
  </div>
)
